/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_0_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Monthly budget for this walkthrough, then select Launch GridCraft.`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_steps_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本次演示先选择 Monthly budget，然后点击 Launch GridCraft。`)
};

/**
* | output |
* | --- |
* | "Choose Monthly budget for this walkthrough, then select Launch GridCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_steps_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_steps_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_steps_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_steps_0 as "gc.search_guides.gridcraft_online.sections.0.steps.0" }